import {Component, Vue} from 'vue-property-decorator'
import {
    getCompanyList, getFinanceInvoiceContent
} from '@/api/financial-center'
import {getCustomerConversionResaleInvoiceList, setCustomerConversionResaleInvoice} from "@/api/customer";
import {delNullProperty} from "@/utils";


@Component({})
export default class ResaleInvoiceRecord extends Vue {
    tableData = []
    loading = false
    newDialogVisible = false
    formRules = {
        titleTypes: [{required: true, message: '请填写抬头类型', trigger: 'blur'}],
        types: [{required: true, message: '请填写开票类型', trigger: 'blur'}],
        title: [{required: true, message: '请填写开票抬头', trigger: 'blur'}],
        content: [{required: true, message: '请填写开票内容', trigger: 'blur'}],
        email: [{required: true, message: '请填写发票接收邮箱', trigger: 'blur'}],
        code: [{required: true, message: '请填写纳税识别号', trigger: 'blur'}],
        address: [{required: true, message: '请输入开票地址', trigger: ['blur', 'change']}],
        phone: [{required: true, message: '请输入电话', trigger: ['blur', 'change']}],
        bank: [{required: true, message: '请输入开户行', trigger: ['blur', 'change']}],
        account: [{required: true, message: '请输入开户账号', trigger: ['blur', 'change']}],
    }
    formData = {
        titleTypes: '',
        types: '',
        title: '',
        code: '',
        email: '',
        bank: '',
        account: '',
        address: '',
        phone: '',
        companyName: '',
        content: '',
        price: '0',
    }
    companyList = []
    titleTypesoptions = [
        {label: '企业单位', value: '0'},
        {label: '个人/非企业单位', value: '1'}
    ]
    makeInvoiceContent = []

    customerConversionName = null
    cooperationName = null
    customerConversionResaleOrderId = null

//     created
    created() {
        /*
        * 转销订单id
        * */
        this.customerConversionResaleOrderId = Number(this.$route.query.id)
        this.cooperationName = this.$route.query.cooperationName
        this.customerConversionName = this.$route.query.customerConversionName

        this.getTableData()
        this.getCompanyList()

    }

//     methods
    async getTableData() {
        this.loading = true
        await getCustomerConversionResaleInvoiceList({customerConversionResaleOrderId: this.customerConversionResaleOrderId}).then((tableData: any) => {
            this.tableData = tableData.customerConversionResaleInvoiceList
            this.loading = false
        }).catch(err=>{
            this.loading = false
        })
    }

    doCancel() {
        this.newDialogVisible = false
        this.formData = {
            titleTypes: '',
            types: '',
            title: '',
            code: '',
            email: '',
            bank: '',
            account: '',
            address: '',
            phone: '',
            companyName: '',
            content: '',
            price: '0',
        }
    }

    doConfirm() {
        if (!this.formData.companyName) {
            this.$message.error('请填写开票公司')
            return
        } else if (!this.formData.price) {
            this.$message.error('请填写本次开票金额')
            return
        }
        (this.$refs['ruleForm'] as any).validate((valid) => {
            if (valid) {
                const obj = {...this.formData, customerConversionResaleOrderId: this.customerConversionResaleOrderId,}
                setCustomerConversionResaleInvoice(delNullProperty(obj)).then(res => {
                    this.$message.success('保存成功')
                    setTimeout(() => {
                        this.getTableData()
                    }, 100)
                    this.formData = {
                        titleTypes: '',
                        types: '',
                        title: '',
                        code: '',
                        email: '',
                        bank: '',
                        account: '',
                        address: '',
                        phone: '',
                        companyName: '',
                        content: '',
                        price: '0',
                    }
                    this.newDialogVisible = false;
                })
            }
        })

    }

    // 所属公司列表
    async getCompanyList() {
        const data: any = await getCompanyList()
        this.companyList = data.companyList
    }

    changeTitleTypes() {
        this.formData.types = ''
    }

    getFinanceInvoiceContent() {
        if (this.formData.companyName) {
            this.makeInvoiceContent = []
            getFinanceInvoiceContent({
                companyName: this.formData.companyName
            }).then((res: any) => {
                if (res.financeInvoiceContent && res.financeInvoiceContent.length > 0)
                    res.financeInvoiceContent.forEach((item) => {
                        this.makeInvoiceContent.push({
                            label: item.content,
                            value: item.types,
                        })
                    })
            })
        } else {
            this.$message.error('请选择开票公司')
        }
    }

    changeCompanyName(val) {
        if (val) {
            this.getFinanceInvoiceContent() // 获取开票内容
            this.formData.content = ''
        }
    }
}